import { render, staticRenderFns } from "./EditSettingsTemplatePage.vue?vue&type=template&id=00c14a19&scoped=true"
import script from "./EditSettingsTemplatePage.vue?vue&type=script&lang=js"
export * from "./EditSettingsTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./EditSettingsTemplatePage.vue?vue&type=style&index=0&id=00c14a19&prod&lang=scss&scoped=true"
import style1 from "./EditSettingsTemplatePage.vue?vue&type=style&index=1&id=00c14a19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c14a19",
  null
  
)

export default component.exports